import React from 'react';
import { getDaysArray } from '@weddingspot/ws-core-components';
import styles from './Calendar.module.scss';

interface DaysListProps {
    month: number;
    year: number;
    getDateClassname?: (day: number, month: number, year: number) => string;
}

const DaysList = ({ month, year, getDateClassname }: DaysListProps) => {
    return (
        <div className={styles.days}>
            {getDaysArray(month, year, true).map((day, index) => (
                <span key={index} className={`${styles.date} ` + (Boolean(getDateClassname) ? getDateClassname(day, month, year) : '')}>
                    {day}
                </span>
            ))}
        </div>
    );
};

export default DaysList;
